/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * sim_shien.csvの1行分のデータ
 * @export
 * @interface SupportInfoData
 */
export interface SupportInfoData {
    /**
     * 日時
     * @type {string}
     * @memberof SupportInfoData
     */
    datetime: string;
    /**
     * タイトル
     * @type {string}
     * @memberof SupportInfoData
     */
    title?: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof SupportInfoData
     */
    message?: string;
    /**
     * レベル
     * @type {number}
     * @memberof SupportInfoData
     */
    level: number;
}

/**
 * Check if a given object implements the SupportInfoData interface.
 */
export function instanceOfSupportInfoData(value: object): value is SupportInfoData {
    if (!('datetime' in value) || value['datetime'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    return true;
}

export function SupportInfoDataFromJSON(json: any): SupportInfoData {
    return SupportInfoDataFromJSONTyped(json, false);
}

export function SupportInfoDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportInfoData {
    if (json == null) {
        return json;
    }
    return {
        
        'datetime': json['datetime'],
        'title': json['title'] == null ? undefined : json['title'],
        'message': json['message'] == null ? undefined : json['message'],
        'level': json['level'],
    };
}

export function SupportInfoDataToJSON(json: any): SupportInfoData {
    return SupportInfoDataToJSONTyped(json, false);
}

export function SupportInfoDataToJSONTyped(value?: SupportInfoData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datetime': value['datetime'],
        'title': value['title'],
        'message': value['message'],
        'level': value['level'],
    };
}

